<style>
    body {
        color: #333;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
    }

    .unordDisc {
        margin-top: 0;
        margin-bottom: 10px;
    }

    .unordDisc > li {
        padding-bottom: 3px;
        font-size: 14px;
    }

    .pad0 {
        padding: 0px !important;
    }
</style>

<body>
    <div class="modal-content wdth70 brdrMob" style="border-radius: 10px; display: flex; flex-direction: column;">
        <div class="modal-body pad0" style="text-align:left;">
            <div class="col-md-12 col-sm-12 col-xs-12 pad0">
                <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 15px 5px 0px 15px;">
                    <span class="closeMdl" style="float: right; margin: 0px !important; padding: 2px 11px !important; top: -10px;" (click)="bzCloseMdl()">
                        <i class="zmdi zmdi-close" style="position: relative; top: 1px;"></i>
                    </span>
                    <div>
                        <span style="font-size: 18px;">Please note that your following details are not updated.</span>
                    </div>      
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 15px; padding-top: 0px;">   
                    <div style="margin-top: 15px;">
                        <ul class="unordDisc" style="list-style-type:disc; padding-left: 20px;">
                            <li *ngIf="!isAdded.compName">Business Name</li>
                            <li *ngIf="!isAdded.address">Address</li>
                            <li *ngIf="!isAdded.city">City</li>
                            <li *ngIf="!isAdded.state">State</li>
                            <li *ngIf="!isAdded.gstin">GSTIN</li>
                            <li *ngIf="!isAdded.logo">Business Logo</li>
                            <li *ngIf="!isAdded.digiSign">Signature Image</li>
                        </ul>  
                    </div>
                    <div style="margin-top: 10px; font-size: 16px;">
                        <span>Are you sure you wish to proceed?</span>
                    </div>
                    <div style="margin-top: 15px" (click)="bzCloseMdl()">
                        <span data-dismiss="modal" class="btn-orange brdrRadius3" style="padding: 3px 8px; text-shadow: 1px 1px 3px rgb(0 0 0 / 10%); font-weight: 500; font-size: 14px; height: 30px;" 
                        (click)="openSetUpProfile()">Update Profile first</span>
                        <span data-dismiss="modal" class="btn darkBlueButton" style="padding: 4px 8px 3px 8px !important; text-shadow: 1px 1px 3px rgb(0 0 0 / 10%); font-weight: 500; font-size: 14px; margin-left: 10px; line-height: 22px; height: 30px;" 
                        (click)="redirectToEntry(docInfo.actionMenuID)">Create {{docInfo.docName}} anyway</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>